import React from 'react'

export const tdBase: React.CSSProperties = {
  height: '48px',
  padding: '0 12px',
  fontSize: '14px',
  fontWeight: 700,
  verticalAlign: 'middle',
  textAlign: 'left',
  borderBottom: '1px solid #e0e0e0',
  color: '#1a1a1a',
  whiteSpace: 'nowrap'
}
